"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionType = exports.OrderStatus = exports.OrderType = void 0;
// Order type enum
var OrderType;
(function (OrderType) {
    OrderType[OrderType["BUY"] = 0] = "BUY";
    OrderType[OrderType["SELL"] = 1] = "SELL";
    OrderType[OrderType["BUY_LIMIT"] = 2] = "BUY_LIMIT";
    OrderType[OrderType["SELL_LIMIT"] = 3] = "SELL_LIMIT";
    OrderType[OrderType["BUY_STOP"] = 4] = "BUY_STOP";
    OrderType[OrderType["SELL_STOP"] = 5] = "SELL_STOP";
})(OrderType || (exports.OrderType = OrderType = {}));
// Order status enum
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["OPEN"] = "OPEN";
    OrderStatus["CLOSED"] = "CLOSED";
})(OrderStatus || (exports.OrderStatus = OrderStatus = {}));
// Transaction type enum
var TransactionType;
(function (TransactionType) {
    TransactionType["DEPOSIT"] = "deposit";
    TransactionType["WITHDRAWAL"] = "withdrawal";
    TransactionType["BALANCE"] = "balance";
    TransactionType["CREDIT"] = "credit";
})(TransactionType || (exports.TransactionType = TransactionType = {}));
